import React from 'react';
import { RegisterInputContainer } from '../../../../../components/ui/InputSearch';
import { InputElement } from '../../../../../ui/Input/Input';
import { IRegisterForm } from '../../../../../interface/Auth/frontend';
import { useTranslation } from 'react-i18next';
import { useNameInput } from '../../../hooks/useNameInput';

interface IProps {
	registerForm: IRegisterForm;
	setRegisterForm(value: IRegisterForm): void;
	isDisabled?: boolean;
}

export const RegFormMiddleName: React.FC<IProps> = ({ registerForm, setRegisterForm, isDisabled }) => {
	const { t } = useTranslation();

	const { handleChange, displayError } = useNameInput({
		citizenshipId: registerForm.citizenshipId,
		fieldName: 'patronymic',
		currentValue: registerForm.patronymic,
		onUpdate: (value) => setRegisterForm({ ...registerForm, patronymic: value })
	});

	return (
		<RegisterInputContainer>
			<InputElement
				placeholder={t('passport.registrationForm.patronymicForm.hint')}
				error={displayError}
				value={registerForm.patronymic}
				disabled={isDisabled}
				onChange={handleChange}
			/>
		</RegisterInputContainer>
	);
};
